import { render } from "./floating.vue?vue&type=template&id=a4d65342&scoped=true"
import script from "./floating.vue?vue&type=script&lang=js"
export * from "./floating.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-a4d65342"

export default script